var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0258 15.8339C18.1439 13.9509 18.206 11.9995 18.206 9.9999C18.206 9.19007 18.1959 8.38814 18.1759 7.59544C18.1619 7.03857 17.9812 6.49738 17.6516 6.04832C16.3952 4.33672 15.3943 3.27264 13.7448 1.99957C13.2915 1.64971 12.7352 1.4599 12.1627 1.44738C11.5887 1.43484 10.9893 1.42847 10.3489 1.42847C8.4104 1.42847 6.84669 1.48685 5.22847 1.59811C3.85185 1.69277 2.75852 2.78867 2.67207 4.16584C2.55389 6.04894 2.49176 8.00034 2.49176 9.9999C2.49176 11.9995 2.55389 13.9509 2.67207 15.8339C2.75852 17.2112 3.85185 18.307 5.22847 18.4016C6.84669 18.5129 8.4104 18.5713 10.3489 18.5713C12.2874 18.5713 13.8511 18.5129 15.4693 18.4016C16.8459 18.307 17.9393 17.2112 18.0258 15.8339Z",
    fill: "white",
    stroke: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62567 10.0222H13.0721",
    stroke: "#C4C4C4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62567 5.71436H10.9123M7.62567 14.1741H13.0552H7.62567Z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.cc993aa5aebb134ee0794f223f120caa.svg";
export { ForwardRef as ReactComponent };